<div  class="booking" *ngIf="downloadRef === false">
  <div
    class="d-flex justify-content-between align-items-center mb-3 py-4 title"
  >
    <h2>{{ viewType === 'invoice' ? 'Invoice Details' : 'Transaction Details' }}</h2>
    <button (click)="bsModalRef?.hide(); hideModal()">
      <fa-icon [icon]="icons.close"></fa-icon>
    </button>
  </div>
  <ng-container *ngIf="viewType === 'transaction'">
  <div class="main py-4 mb-3">
    <!-- <div class=""> -->
    <div class="mb-3 pb-3 d-flex justify-content-between align-items-start">
      <div>
        <p class="booking-sm-caption">Transaction ID</p>
        <p class="mb-0 booking-text-bold">
          {{ payment?.transaction?.id }}
        </p>
      </div>
      <div class="pt-4">
        <span class="booking-sucess">{{ payment.status }}</span>
      </div>
      <!-- </div> -->
    </div>
    <div class="border-top py-3">
      <p class="booking-sm-caption">Employee</p>
        <div class="d-flex align-items- align-self-end">
        <img
          class="booking-img"
          src="{{ payment?.employee?.user.avatar }}"
          alt="{{ payment?.employee?.user.first_name }}"
        />
        <div class="ms-4">
          <div class="d-flex flex-column">
            <h4 class="booking-text-bold">
              {{
                payment?.employee?.user.first_name +
                  " " +
                  payment?.employee?.user.last_name
              }}
            </h4>
            <a class="booking-link">
              <p class="">{{ payment?.employee?.user.email }}</p>
            </a>
          </div>
        </div>
      </div>
    </div>
    <ng-container *ngIf="payment?.trip?.booking_service === 'booking'">
      <div
        class="mb-3 border-top d-flex justify-content-between align-items-center py-3"
      >
        <div>
          <p class="booking-sm-caption">Date</p>
          <p class="mb-0 booking-text-bold">
            {{ payment?.trip?.booking?.createdAt | date }}
          </p>
        </div>
      </div>
      <div class="mb-3 border-top py-3">
        <p class="booking-sm-caption">Description</p>
        <p class="mb-0 booking-text-bold">
          {{ payment?.trip?.booking?.listing?.property?.display_name }}
        </p>
        <div class="d-flex align-items-center booking-dets">
          <fa-icon class="me-2" [icon]="icons.bedBunk"></fa-icon>
          <p>
            {{ payment?.trip?.booking?.listing?.property?.total_rooms }}
          </p>
          <span class="dot-circle-alt ms-3 me-3"></span>
          <fa-icon class="me-2" [icon]="icons.bath"></fa-icon>
          <p>
            {{ payment?.trip?.booking?.listing?.property?.bathrooms }}
          </p>
          <span class="dot-circle-alt ms-3 me-3"></span>
          <fa-icon class="me-2" [icon]="icons.mapMaker"></fa-icon>
          <p>
            {{ payment?.trip?.booking?.listing?.property?.address?.street || "" }}
          </p>
        </div>
      </div>
      <div class="mb-3 border-top py-3 booking-sm-caption">
        <p>Guest(s)</p>
        <p class="mb-0 booking-text-bold">
          {{ payment?.trip?.booking?.guests | occupants }}
        </p>
      </div>
      <div class="mb-3 border-top py-3">
        <p class="booking-sm-caption">Check in & Check out</p>
        <p class="mb-0 booking-text-bold">
          {{ payment?.trip?.booking?.check_in | date }} -
          {{ payment?.trip?.booking?.check_out | date }}
        </p>
      </div>
      <div class="mb-3 border-top py-3">
        <p class="booking-sm-caption">Amount</p>
        <p class="mb-0 booking-text-bold amount">
          {{
            payment?.transaction?.amount
              | currency : payment?.transaction?.currency?.toUpperCase()
          }}
        </p>
      </div>
    </ng-container>
    <ng-container *ngIf="payment?.trip?.booking_service === 'flightBooking'">
      <div
        class="mb-3 border-top d-flex justify-content-between align-items-center py-3"
      >
        <div>
          <p class="booking-sm-caption">Date</p>
          <p class="mb-0 booking-text-bold">
            {{ payment?.trip?.flightbooking?.createdAt | date }}
          </p>
        </div>
      </div>
      <div class="mb-3 border-top py-3 booking-sm-caption">
        <p>Trip type</p>
        <p class="mb-0 booking-text-bold">
           {{
                      payment?.trip?.flightbooking?.trip_type === 'OneWay' ? 'One Way' : payment?.trip?.flightbooking?.trip_type === 'RoundTrip' ? 'Round Trip' : 'Multi Destination'
                      }}
        </p>
      </div>
      <div class="mb-3 border-top py-3">
        <p class="booking-sm-caption">Description</p>
        <div>

          <div class="mb-0 booking-text-bold" *ngFor="let data of payment?.trip?.flightbooking?.meta?.flight_details?.flight_group; let i = index; even as isEven">
              <small class="d-flex duration gap-3 ">
                      <fa-icon [icon]="isEven ? icons.departure : icons.arrival"></fa-icon>
                      <!-- {{isEven ? 'Departure' : 'Return'}} -->
                    </small>
                    <small>
                      {{data?.departure?.airport?.city}} ({{data?.departure?.airport?.code}})
                    </small>
                    <fa-icon [icon]="icons.arrowRight"></fa-icon>
                    <small>
                      {{data?.arrival?.airport?.city}} ({{data?.arrival?.airport?.code}})
                    </small>
                    <img src="/assets/images/dot.svg" alt="Dot" class="dot" />

                    <small class="date">
                      {{data?.departure?.datetime?.date_time | date:
                      'mediumDate' }} - {{data?.arrival?.datetime?.date_time | date:
                      'mediumDate'}}
                    </small>
          </div>
        </div>
       
      </div>
      <div class="mb-3 border-top py-3 booking-sm-caption">
        <p>Traveler(s)</p>
        <p class="mb-0 booking-text-bold w-100">
                                <span>{{payment?.trip?.flightbooking?.travelers?.adults ? payment?.trip?.flightbooking?.travelers?.adults : 0}} Adult, </span>
                      <span>{{payment?.trip?.flightbooking?.travelers?.children ? payment?.trip?.flightbooking?.travelers?.children : 0}} Children, </span> <br>
                      <span>{{payment?.trip?.flightbooking?.travelers?.infants ? payment?.trip?.flightbooking?.travelers?.infants : 0}} Infant </span>

        </p>
      </div>
      
      <div class="mb-3 border-top py-3">
        <p class="booking-sm-caption">Amount</p>
        <p class="mb-0 booking-text-bold amount">
          {{
            payment?.transaction?.amount
              | currency : payment?.transaction?.currency?.toUpperCase()
          }}
        </p>
      </div>
    </ng-container>
    <div class="mt-4">
      <button #downloadButton class="btn btn-download w-100" (click)="downloadReceiptAsPDF()">Download Receipt</button>
    </div>
  </div>
  </ng-container>

  <ng-container *ngIf="viewType === 'invoice'">
    <div class="main py-4 mb-3">
      <div class="mb-3 border-bottom pb-3 d-flex justify-content-between align-items-start">
        <div>
          <p class="booking-sm-caption">Invoice ID</p>
          <p class="mb-0 booking-text-bold">{{ invoiceData?._id || invoiceData?.id }}</p>
        </div>
        <div class="pt-2">
           <span class="badge rounded-pill" [ngStyle]="{'background-color': invoiceData?.status?.toLowerCase() === 'paid' ? '#d1f2e5' : '#fde0e0', 'color': invoiceData?.status?.toLowerCase() === 'paid' ? '#46b286' : '#f75656', 'padding': '6px 12px', 'font-weight': '500'}">
             {{ invoiceData?.status | titlecase }}
           </span>
        </div>
      </div>
      <div class="mb-3 border-bottom pb-3">
        <p class="booking-sm-caption">Invoice Type</p>
        <p class="mb-0 booking-text-bold">{{ invoiceData?.type ?? 'Single Booking' }}</p>
      </div>
      <div class="mb-3 border-bottom pb-3">
        <p class="booking-sm-caption">Duration</p>
        <p class="mb-0 booking-text-bold">{{ invoiceData?.billing_period_start | date: 'dd MMM' }} - {{ invoiceData?.billing_period_end | date: 'dd MMM yyyy' }}</p>
      </div>
      <div class="mb-3 border-bottom pb-3">
        <p class="booking-sm-caption">No of Bookings</p>
        <p class="mb-0 booking-text-bold">{{ invoiceData?.no_of_bookings || 1 }}</p>
      </div>
      <div class="mb-3 border-bottom pb-3">
        <p class="booking-sm-caption">Date</p>
        <p class="mb-0 booking-text-bold">{{ invoiceData?.createdAt | date: 'dd MMM yyyy' }}</p>
      </div>
      <div class="mb-3 pb-3">
        <p class="booking-sm-caption">Amount</p>
        <p class="mb-0 booking-text-bold amount" style="color: #1a4d59;">
          {{ invoiceData?.amount | currency: invoiceData?.currency:'symbol':'1.2-2' }}
        </p>
      </div>
      <div class="mt-4">
        <button class="btn btn-download w-100" (click)="downloadInvoicePDF()" [disabled]="downloadingInvoice" style="background-color: #F8C53A; border: none; color: #101828; font-weight: 500;">
          {{ downloadingInvoice ? 'Downloading...' : 'Download Invoice' }}
        </button>
      </div>
    </div>
  </ng-container>
</div>
<div #modalContent  class="booking" *ngIf="downloadRef === true"   >
  <div
    class="d-flex justify-content-between align-items-center mb-3 py-4 title"
  >
    <h2>{{ viewType === 'invoice' ? 'Invoice Receipt' : 'Transaction Receipt' }}</h2>
    
  </div>
  <ng-container *ngIf="viewType === 'invoice'">
    <div class="main py-4 mb-3">
      <div class="mb-3 pb-3 d-flex justify-content-between align-items-start">
        <div>
          <p class="booking-sm-caption">Invoice ID</p>
          <p class="mb-0 booking-text-bold">
            {{ (updatedInvoice?._id || updatedInvoice?.id || invoiceData?._id || invoiceData?.id) }}
          </p>
        </div>
        <div class="pt-4">
          <span [ngClass]="(updatedInvoice?.status || invoiceData?.status)?.toLowerCase() === 'paid' ? 'booking-sucess' : 'booking-cancel'">
            {{ ((updatedInvoice?.status || invoiceData?.status) | titlecase) }}
          </span>
        </div>
      </div>

      <div class="border-top py-3">
        <p class="booking-sm-caption">Invoice Type</p>
        <p class="mb-0 booking-text-bold">{{ (updatedInvoice?.type ?? invoiceData?.type ?? 'Single Booking') }}</p>
      </div>
      <div class="border-top py-3">
        <p class="booking-sm-caption">Duration</p>
        <p class="mb-0 booking-text-bold">
          {{ ((updatedInvoice?.billing_period_start || invoiceData?.billing_period_start) | date: 'dd MMM') }} -
          {{ ((updatedInvoice?.billing_period_end || invoiceData?.billing_period_end) | date: 'dd MMM yyyy') }}
        </p>
      </div>
      <div class="border-top py-3">
        <p class="booking-sm-caption">No of Bookings</p>
        <p class="mb-0 booking-text-bold">
          {{ (updatedInvoice?.no_of_bookings || invoiceData?.no_of_bookings || 1) }}
        </p>
      </div>
      <div class="border-top py-3">
        <p class="booking-sm-caption">Date</p>
        <p class="mb-0 booking-text-bold">
          {{ ((updatedInvoice?.createdAt || invoiceData?.createdAt) | date: 'mediumDate') }}
        </p>
      </div>
      <div class="border-top py-3">
        <p class="booking-sm-caption">Amount</p>
        <p class="mb-0 booking-text-bold amount">
          {{ ((updatedInvoice?.amount || invoiceData?.amount) | currency: (updatedInvoice?.currency || invoiceData?.currency):'symbol':'1.2-2') }}
        </p>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="viewType !== 'invoice'">
   <div class="main py-4 mb-3">
    <!-- <div class=""> -->
    <div class="mb-3 pb-3 d-flex justify-content-between align-items-start">
      <div>
        <p class="booking-sm-caption">Transaction ID</p>
        <p class="mb-0 booking-text-bold">
          {{ payment?.transaction?.id }}
        </p>
      </div>
      <div class="pt-4">
        <span class="booking-sucess">{{ payment.status }}</span>
      </div>
      <!-- </div> -->
    </div>
    <div class="border-top py-3">
      <p class="booking-sm-caption">Employee</p>
        <div class="d-flex align-items- align-self-end">
        <img
          class="booking-img"
          src="{{ payment.employee.user.avatar }}"
          alt="{{ payment.employee.user.first_name }}"
        />
        <div class="ms-4">
          <div class="d-flex flex-column">
            <h4 class="booking-text-bold">
              {{
                payment.employee.user.first_name +
                  " " +
                  payment.employee.user.last_name
              }}
            </h4>
            <a class="booking-link">
              <p class="">{{ payment.employee.user.email }}</p>
            </a>
          </div>
        </div>
      </div>
    </div>
    <ng-container *ngIf="payment?.trip?.booking_service === 'booking'">
      <div
        class="mb-3 border-top d-flex justify-content-between align-items-center py-3"
      >
        <div>
          <p class="booking-sm-caption">Date</p>
          <p class="mb-0 booking-text-bold">
            {{ payment?.trip?.booking?.createdAt | date }}
          </p>
        </div>
      </div>
      <div class="mb-3 border-top py-3">
        <p class="booking-sm-caption">Description</p>
        <p class="mb-0 booking-text-bold">
          {{ payment?.trip?.booking?.listing?.property?.display_name }}
        </p>
        <div class="d-flex align-items-center booking-dets">
          <fa-icon class="me-2" [icon]="icons.bedBunk"></fa-icon>
          <p>
            {{ payment?.trip?.booking?.listing?.property?.total_rooms }}
          </p>
          <span class="dot-circle-alt ms-3 me-3"></span>
          <fa-icon class="me-2" [icon]="icons.bath"></fa-icon>
          <p>
            {{ payment?.trip?.booking?.listing?.property?.bathrooms }}
          </p>
          <span class="dot-circle-alt ms-3 me-3"></span>
          <fa-icon class="me-2" [icon]="icons.mapMaker"></fa-icon>
          <p>
            {{ payment?.trip?.booking?.listing?.property?.address?.street || "" }}
          </p>
        </div>
      </div>
      <div class="mb-3 border-top py-3 booking-sm-caption">
        <p>Guest(s)</p>
        <p class="mb-0 booking-text-bold">
          {{ payment?.trip?.booking?.guests | occupants }}
        </p>
      </div>
      <div class="mb-3 border-top py-3">
        <p class="booking-sm-caption">Check in & Check out</p>
        <p class="mb-0 booking-text-bold">
          {{ payment?.trip?.booking?.check_in | date }} -
          {{ payment?.trip?.booking?.check_out | date }}
        </p>
      </div>
      <div class="mb-3 border-top py-3">
        <p class="booking-sm-caption">Amount</p>
        <p class="mb-0 booking-text-bold amount">
          {{
            payment?.transaction?.amount
              | currency : payment?.transaction?.currency?.toUpperCase()
          }}
        </p>
      </div>
    </ng-container>
    <ng-container *ngIf="payment?.trip?.booking_service === 'flightBooking'">
      <div
        class="mb-3 border-top d-flex justify-content-between align-items-center py-3"
      >
        <div>
          <p class="booking-sm-caption">Date</p>
          <p class="mb-0 booking-text-bold">
            {{ payment?.trip?.flightbooking?.createdAt | date }}
          </p>
        </div>
      </div>
      <div class="mb-3 border-top py-3 booking-sm-caption">
        <p>Trip type</p>
        <p class="mb-0 booking-text-bold">
           {{
                      payment?.trip?.flightbooking?.trip_type === 'OneWay' ? 'One Way' : payment?.trip?.flightbooking?.trip_type === 'RoundTrip' ? 'Round Trip' : 'Multi Destination'
                      }}
        </p>
      </div>
      <div class="mb-3 border-top py-3">
        <p class="booking-sm-caption">Description</p>
        <div>

          <div class="mb-0 booking-text-bold" *ngFor="let data of payment?.trip?.flightbooking?.meta?.flight_details?.flight_group; let i = index; even as isEven">
              <small class="d-flex duration gap-3 ">
                      <fa-icon [icon]="isEven ? icons.departure : icons.arrival"></fa-icon>
                      <!-- {{isEven ? 'Departure' : 'Return'}} -->
                    </small>
                    <small>
                      {{data?.departure?.airport?.city}} ({{data?.departure?.airport?.code}})
                    </small>
                    <fa-icon [icon]="icons.arrowRight"></fa-icon>
                    <small>
                      {{data?.arrival?.airport?.city}} ({{data?.arrival?.airport?.code}})
                    </small>
                    <img src="/assets/images/dot.svg" alt="Dot" class="dot" />

                    <small class="date">
                      {{data?.departure?.datetime?.date_time | date:
                      'mediumDate' }} - {{data?.arrival?.datetime?.date_time | date:
                      'mediumDate'}}
                    </small>
          </div>
        </div>
       
      </div>
      <div class="mb-3 border-top py-3 booking-sm-caption">
        <p>Traveler(s)</p>
        <p class="mb-0 booking-text-bold w-100">
                                <span>{{payment?.trip?.flightbooking?.travelers.adults ? payment?.trip?.flightbooking?.travelers.adults : 0}} Adult, </span>
                      <span>{{payment?.trip?.flightbooking?.travelers.children ? payment?.trip?.flightbooking?.travelers.children : 0}} Children, </span> <br>
                      <span>{{payment?.trip?.flightbooking?.travelers.infants ? payment?.trip?.flightbooking?.travelers.infants : 0}} Infant </span>

        </p>
      </div>
      
      <div class="mb-3 border-top py-3">
        <p class="booking-sm-caption">Amount</p>
        <p class="mb-0 booking-text-bold amount">
          {{
            payment?.transaction?.amount
              | currency : payment?.transaction?.currency?.toUpperCase()
          }}
        </p>
      </div>
    </ng-container>
    <!-- <div class="mt-4">
      <button #downloadButton class="btn btn-download w-100" (click)="downloadReceiptAsPDF()">Download Receipt</button>
    </div> -->
  </div>
  </ng-container>
</div>
